import { useState } from 'react';
import MaterialIcon from '@material/react-material-icon';
import InputLabel from '@mui/material/InputLabel';
import ListItemText from '@mui/material/ListItemText';
import Modal from '@mui/material/Modal';
import Radio from '@mui/material/Radio';
import FormControl from '@mui/material/FormControl';
import { Button } from '@upmc/ims.component-library';

import styles from './CustomizeFavorites.module.scss';

const CustomSelectDropdown = ({
	label,
	labelId,
	handleAdd,
	handleRemove,
	options,
	tempFavorites,
	updateIndex,
}) => {
	const [open, setOpen] = useState(false);

	const flattenChildItemsFromTopLevelParent = (
		topLevelParent,
		flatList = []
	) => {
		//for each item in topLevelParent, pull out all child items that are not parents and place in flat list recursively

		topLevelParent.ChildItems.forEach(x => {
			if (!x.IsParentItem) {
				flatList.push(x);
			} else {
				let parentItems = [];
				let separatedItems = separateChildItemsFromParentItems(x);
				flatList = flatList.concat(separatedItems.childItems);
				parentItems = parentItems.concat(separatedItems.parentItems);
				parentItems.forEach(x => {
					flattenChildItemsFromTopLevelParent(x, flatList);
				});
			}
		});

		return flatList;
	};

	const separateChildItemsFromParentItems = item => {
		let childItems = [];
		let parentItems = [];
		item.ChildItems.forEach(x => {
			if (x.IsParentItem) {
				parentItems.push(x);
			} else {
				childItems.push(x);
			}
		});

		return {
			childItems,
			parentItems,
		};
	};

	const handleOpen = e => {
		setOpen(!open);
	};

	return (
		<div className={styles.selection_container}>
			<div>
				<Button
					size={'small'}
					sx={{m: '0 5px 5px 5px'}}
					onClick={e => {
						handleOpen(e);
					}}
					startIcon={<MaterialIcon icon='edit' />}
					variant='text'
				>
					Edit
				</Button>
				{tempFavorites[updateIndex].ID ? (
					<Button
						size={'small'}
						variant='text'
						sx={{m: '0 5px 5px 5px'}}
						onClick={e =>
							handleRemove(
								e,
								updateIndex,
								tempFavorites[updateIndex]
							)
						}
						startIcon={<MaterialIcon icon='delete' />}
					>
						Remove
					</Button>
				) : null}
			</div>

			<div className={styles.currentValueDisplay_flexContainter}>
				<p>{updateIndex + 1}. &nbsp;</p>
				<div
					className={styles.labelDisplay}
					onClick={e => {
						handleOpen(e);
					}}
				>
					<p>{label}</p>
				</div>
			</div>
			<FormControl size='small'>
				<InputLabel id={labelId}>{label}</InputLabel>

				<Modal open={open}>
					<div className={styles.Modal} style={{}}>
						<div className={styles.ModalContent}>
							{options
								? options.map((option, index) => (
										<div key={option.ID}>
											<div
												className={styles.SelectSection}
											>
												<div
													className={
														styles.SelectSectionBanner
													}
												>
													{option.Name}
												</div>
												<Button
													onClick={e => {
														handleOpen(e);
													}}
													variant='text'
													startIcon={
														<MaterialIcon icon='close' />
													}
												>
													Close
												</Button>
											</div>
											{flattenChildItemsFromTopLevelParent(
												option
											)
												.sort((a, b) => {
													return a.Name < b.Name
														? -1
														: a.Name > b.Name
														? 1
														: 0;
												})
												.map(child => {
													return (
														<div key={child.ID}>
															{tempFavorites.filter(
																x =>
																	x.ID ===
																	child.ID
															).length < 1 ? (
																//button to add at this index
																<div
																	className={
																		styles.RadioButtonContainer
																	}
																	key={
																		child.ID
																	}
																>
																	<Radio
																		checked={
																			false
																		}
																		onClick={e => {
																			handleAdd(
																				e,
																				updateIndex,
																				child
																			);
																			handleOpen(
																				e
																			);
																		}}
																	/>
																	<div>
																		<ListItemText
																			primary={
																				child.Name
																			}
																		/>
																	</div>
																</div>
															) : tempFavorites.findIndex(
																	item => {
																		if (
																			item.ID ===
																			child.ID
																		) {
																			return true;
																		}
																		return false;
																	}
															  ) ===
															  updateIndex ? (
																<div
																	key={
																		child.ID
																	}
																	className={
																		styles.RadioButtonContainer
																	}
																>
																	<Radio
																		checked={
																			true
																		}
																	/>

																	<div>
																		<ListItemText
																			primary={
																				child.Name
																			}
																		/>
																	</div>
																</div>
															) : (
																<div
																	key={
																		child.ID
																	}
																	className={
																		styles.RadioButtonContainer
																	}
																>
																	<Radio
																		checked={
																			true
																		}
																		disabled={
																			true
																		}
																	/>

																	<div>
																		<ListItemText
																			primary={
																				child.Name
																			}
																		/>
																	</div>
																	<div
																		className={
																			styles.DisabledText
																		}
																	>
																		(item
																		already
																		favorited)
																	</div>
																</div>
															)}
														</div>
													);
												})}
										</div>
								  ))
								: null}
						</div>
					</div>
				</Modal>
			</FormControl>
		</div>
	);
};

export default CustomSelectDropdown;
